import { RoleTypeDto } from '@/api/generated/models/role-type-dto';
import { UserPermissionDto } from '@/api/generated/models/user-permission-dto';

import { RouteEnum } from './Route.model';

const ReqLrmAdm = [RoleTypeDto.Requester, RoleTypeDto.LocalResourceManager, RoleTypeDto.Admin];

export const ROUTES_ROLES: Record<RouteEnum, RoleTypeDto[]> = {
  [RouteEnum.ADD_VACANCY]: [...ReqLrmAdm, RoleTypeDto.PreSales],
  [RouteEnum.ASSESSMENT_EDIT]: [],
  [RouteEnum.ASSESSMENT_ID]: [],
  [RouteEnum.ASSESSMENTS]: [],
  [RouteEnum.CANDIDATES]: [...ReqLrmAdm],
  [RouteEnum.CANDIDATES_ID]: [...ReqLrmAdm],
  [RouteEnum.CERTIFICATES_MANAGEMENT]: [RoleTypeDto.Admin, RoleTypeDto.LocalResourceManager],
  [RouteEnum.COMPANIES]: [...ReqLrmAdm],
  [RouteEnum.COMPANIES_ID]: [...ReqLrmAdm],
  [RouteEnum.COMPANY_EMPLOYEE]: [...ReqLrmAdm],
  [RouteEnum.DICTIONARIES]: [RoleTypeDto.Admin, RoleTypeDto.LocalResourceManager],
  [RouteEnum.EDIT_VACANCY]: [...ReqLrmAdm, RoleTypeDto.PreSales, RoleTypeDto.GroupExternalPartner],
  [RouteEnum.FORBIDDEN]: [],
  [RouteEnum.LOGIN]: [],
  [RouteEnum.LOGIN_SUCCESSFUL]: [],
  [RouteEnum.MAINTENANCE]: [],
  [RouteEnum.MY_PROFILE]: [...ReqLrmAdm, RoleTypeDto.PreSales, RoleTypeDto.Employee],
  [RouteEnum.NOT_AUTHORIZED]: [],
  [RouteEnum.NOT_FOUND]: [],
  [RouteEnum.OFFERINGS_MANAGEMENT]: [RoleTypeDto.Admin, RoleTypeDto.LocalResourceManager],
  [RouteEnum.OVERVIEW]: [...ReqLrmAdm, RoleTypeDto.Employee],
  [RouteEnum.PROFILE_SEARCH]: [...ReqLrmAdm, RoleTypeDto.Employee],
  [RouteEnum.PROFILE_SEARCH_NEW]: [...ReqLrmAdm, RoleTypeDto.Employee],
  [RouteEnum.PROJECT_DETAILS]: [...ReqLrmAdm, RoleTypeDto.PreSales],

  [RouteEnum.RECRUITMENT_BOARD]: [
    ...ReqLrmAdm,
    RoleTypeDto.PreSales,
    RoleTypeDto.ExternalPartner,
    RoleTypeDto.GroupExternalPartner,
  ],
  [RouteEnum.REPORTS]: [RoleTypeDto.Admin, RoleTypeDto.LocalResourceManager],
  [RouteEnum.ROOT]: [],
  [RouteEnum.SKILLS_MANAGEMENT]: [RoleTypeDto.Admin, RoleTypeDto.LocalResourceManager],
  [RouteEnum.USER_PROFILE]: [...ReqLrmAdm, RoleTypeDto.PreSales, RoleTypeDto.Employee],
  [RouteEnum.USERS_INITIALIZE]: [],
  [RouteEnum.USERS_SIGN_PRIVACY_POLICY]: [],
  [RouteEnum.VACANCIES_CANDIDATE]: [
    ...ReqLrmAdm,
    RoleTypeDto.ExternalPartner,
    RoleTypeDto.GroupExternalPartner,
  ],
  [RouteEnum.VACANCY_ID]: [
    ...ReqLrmAdm,
    RoleTypeDto.PreSales,
    RoleTypeDto.ExternalPartner,
    RoleTypeDto.GroupExternalPartner,
  ],
  [RouteEnum.VACANCY_PROJECTS]: [...ReqLrmAdm, RoleTypeDto.PreSales],
  [RouteEnum.WAITING_FOR_APPROVAL]: [],
};

export const ROUTES_PERMISSIONS: Partial<Record<RouteEnum, UserPermissionDto[]>> = {
  [RouteEnum.ASSESSMENT_EDIT]: [UserPermissionDto.AssessmentView],
  [RouteEnum.ASSESSMENT_ID]: [UserPermissionDto.AssessmentView],
  [RouteEnum.ASSESSMENTS]: [UserPermissionDto.AssessmentView],
};
